import React from 'react'
import {HStack, useMultiStyleConfig} from '@chakra-ui/react'
import {RATING_MAX_STARS} from '../../constants'
import {StarEmptyIcon} from '../icons'

const RatingSkeleton = (props) => {
    const styles = useMultiStyleConfig('Ratings', props)

    return (
        <HStack {...styles.container}>
            {Array.from({length: RATING_MAX_STARS}).map((_, i) => (
                <StarEmptyIcon key={i} {...styles.star} data-testid="empty-star" />
            ))}
        </HStack>
    )
}

export default RatingSkeleton
